import { render, staticRenderFns } from "./integrations.vue?vue&type=template&id=79a246d4&scoped=true&"
import script from "./integrations.vue?vue&type=script&lang=js&"
export * from "./integrations.vue?vue&type=script&lang=js&"
import style0 from "../less/profileSettings.less?vue&type=style&index=0&id=79a246d4&scoped=true&lang=css&"
import style1 from "./integrations.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79a246d4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79a246d4')) {
      api.createRecord('79a246d4', component.options)
    } else {
      api.reload('79a246d4', component.options)
    }
    module.hot.accept("./integrations.vue?vue&type=template&id=79a246d4&scoped=true&", function () {
      api.rerender('79a246d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/profileSettings/pages/integrations.vue"
export default component.exports